import {
    SET_EVENT,
    FETCH_QUERY_EVENTS_FETCHING,
    FETCH_QUERY_EVENTS_SUCCESS,
    FETCH_QUERY_EVENTS_FAIL,
    RESET_QUERY_EVENTS,
    UPDATE_QUERY_EVENTS
} from 'actions/eventBasedGoalActions';

const INITIAL_STATE = {
    query: {
        events: null,
        fetching: false,
        success: false,
        error: false
    },
    event: {}
};

export const getQueriedEvents = (state) => {
    return state.eventBasedGoals.query.events;
};

export const getEvent = (state) => {
    return state.eventBasedGoals.event;
};

export const isQueriedEventsFetching = (state) => {
    return state.eventBasedGoals.query.fetching;
};

export const isQueriedEventsSuccess = (state) => {
    return state.eventBasedGoals.query.success;
};

export const isQueriedEventsError = (state) => {
    return state.eventBasedGoals.query.error;
};

const queriedEventsSuccess = (success) => (state, action) => {
    return {
        ...state,
        query: {
            ...state.query,
            events: success ? action.data : null,
            success: success,
            error: !success,
            fetching: false
        }
    };
};

const queriedEventsFetching = (state, action) => {
    return {
        ...state,
        query: {
            ...state.query,
            events: null,
            fetching: true,
            error: false,
            success: false
        }
    };
};

const resetQuery = (state) => {
    return {
        ...state,
        query: INITIAL_STATE.query
    };
};

const updateQueryEvents = (state, action) => {
    return {
        ...state,
        query: {
            ...state.query,
            events: action.events
        }
    };
};

const setEvent = (state, action) => {
    return {
        ...state,
        event: { ...action.event }
    };
};

const handlers = {
    [FETCH_QUERY_EVENTS_SUCCESS]: queriedEventsSuccess(true),
    [FETCH_QUERY_EVENTS_FETCHING]: queriedEventsFetching,
    [FETCH_QUERY_EVENTS_FAIL]: queriedEventsSuccess(false),
    [RESET_QUERY_EVENTS]: resetQuery,
    [UPDATE_QUERY_EVENTS]: updateQueryEvents,
    [SET_EVENT]: setEvent
};

export default function eventBasedGoals(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) {
        return state;
    } else {
        return handler(state, action);
    }
}
